// Public Mapbox token + house map style, shared by every dashboard map
// (the CustomDash GenericMap choropleth and the economic-impact map) so a
// token rotation or style version bump only happens in one place.
export const MAPBOX_TOKEN =
  'pk.eyJ1IjoicmV2ZWxpb2xhYnMiLCJhIjoiY2w3N3pjM2tlMDRuczN2cXB1ZTU3bWZvdyJ9.AluK-n7WOv2tAOhTL-ZzAQ';

export const MAPBOX_STYLE_URL =
  'mapbox://styles/reveliolabs/cmgh3e8x6001v01sogcc11itl?optimize=true';

export const MAPBOX_LIGHT_STYLE_URL =
  'mapbox://styles/reveliolabs/cmrckkrd1000001r5354d7648?optimize=true';

export const MAPBOX_DARK_STYLE_URL =
  'mapbox://styles/reveliolabs/cmrckd501002a01ss7dd4h994?optimize=true';
